import { createFileRoute } from '@tanstack/react-router';
import { LiveMatrixScreen } from '@/features/allergens/LiveMatrixScreen';
import { parseMatrixSearch, type MatrixSearch } from '@/features/allergens/lib/search';

/** v0.2's matrix URL, kept for existing links (the menu builder's
 *  Allergens button, the recipe editor, bookmarks). The same screen as
 *  /allergens; with no mode it shows dishes and prep, as it always has. */
export const Route = createFileRoute('/_app/allergens/matrix')({
  validateSearch: (s: Record<string, unknown>): MatrixSearch => parseMatrixSearch(s),
  component: MatrixRoute,
});

function MatrixRoute() {
  const search = Route.useSearch();
  return <LiveMatrixScreen search={{ ...search, mode: search.mode ?? 'recipes' }} />;
}
